/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Deliveries_Chart_TitleInputs */

const vi_dashboard_driver_deliveries_chart_title = /** @type {(inputs: Dashboard_Driver_Deliveries_Chart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hàng 7 ngày qua`)
};

/**

* @param {Dashboard_Driver_Deliveries_Chart_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_deliveries_chart_title = /** @type {((inputs?: Dashboard_Driver_Deliveries_Chart_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Deliveries_Chart_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_deliveries_chart_title(inputs)
});